import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function CategoryQuickLinks() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
        {categories.map((category, index) => (
          <Link
            key={category.key}
            to={`/category/${category.key}`}
            className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5 animate-fade-up"
            style={{ animationDelay: `${index * 60}ms` }}
          >
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${category.icon} text-2xl`} aria-hidden="true" />
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">{category.name}</h3>
                <p className="text-xs text-foreground-500">进入分类</p>
              </div>
            </div>
            <p className="mt-3 line-clamp-2 text-xs leading-relaxed text-foreground-500">
              {category.desc}
            </p>
            <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-600">
              立即浏览
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}